export default class Promotion {
  constructor() {
    this.id = "";
    this.agentid = "";
    this.day = 0;
    this.discountRate = 0;
    this.isEnable = false;
    this.minimalAmount = 0;
    this.scheduleName = "";
    this.shopid = "";
    this.vendorid = "";
    this.remark = "";
    this.startTime = "";
    this.endTime = "";
    this.checkedWeek = [];
    this.timeRange = "";
  }
}
